import styled from 'styled-components';
import IconArrowDown from './IconArrowDown';
var IconArrowUp = /*#__PURE__*/styled(IconArrowDown).withConfig({
  displayName: "IconArrowUp",
  componentId: "c11n-8-111-1__sc-sxqevw-0"
})(["transform:rotate(180deg);"]);
export default IconArrowUp;